// extracted by mini-css-extract-plugin
export var addButton = "_ed-4";
export var contentBlockImage = "_ed-i";
export var contentBlockWidgetPreview = "_ed-g";
export var fulfillmentCutoffWidgetPreview = "_ed-9";
export var imageBackdrop = "_ed-6";
export var imageIcon = "_ed-8";
export var lowProfileImageContainer = "_ed-b";
export var lowProfileImageIcon = "_ed-f";
export var lowProfileImageIconContainer = "_ed-e";
export var lowProfileImagePlaceholder = "_ed-d";
export var lowProfileProductImage = "_ed-c";
export var lowProfileProductUpsellWidgetPreview = "_ed-a";
export var productCard = "_ed-5";
export var productImage = "_ed-7";
export var productReviewsWidgetPreview = "_ed-h";
export var progressBar = "_ed-1";
export var progressBarFill = "_ed-2";
export var progressBarTrack = "_ed-3";
export var shippingOptionWidgetPreview = "_ed-j";
export var shippingUpsellProgressBar = "_ed-k";
export var thresholdUpsellWidgetPreview = "_ed-0";